<template>
	<div class="ReportHelp">
		<!-- Help button hollow -->
		<CloButton
			v-if="hollow"
			id="help-btn"
			icon="help"
			size="sm"
			hollow
			reverse
			@click.native="showDialog"
			/>
		<!-- Help button default -->
		<button v-else id="help-btn" class="Button Button--reverse Button--link" @click="showDialog">
			<CloIcon symbol="help"/>
		</button>
		<!-- Help dialog -->
		<CloDialog v-show="dialogOpen" id="help-dialog" @close="closeDialog">
			<template #header>
				<CloHeading level="2">{{ $t('tripReport.help') }}</CloHeading>
			</template>
			<template #body>
				<p>{{ $t('tripReport.helpDesc') }}</p>
				<a :href="tripReportsHelpUrl" class="Button u-margin-none">{{ $t('generic.learnMore') }}</a>
			</template>
		</CloDialog>
	</div>
</template>

<script>
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import CloButton from '@/base/CloButton/CloButton.vue';
import CloIcon from '@/icons/CloIcon/CloIcon.vue';
import CloDialog from '@/base/CloDialog/CloDialog.vue';
export default {
	name: 'ReportHelp',
	components: {
		CloHeading,
		CloButton,
		CloIcon,
		CloDialog,
	},
	props: {
		hollow: Boolean,
	},
	data() {
		return {
			tripApiBaseUrl: window.tripApiBaseUrl,
			tripReportsHelpUrl: window.tripReportsHelpUrl,
			dialogOpen: false,
			dialogOpener: null,
		};
	},
	methods: {
		showDialog(e) {
			this.dialogOpen = true;
			this.dialogOpener = e.target;
		},
		closeDialog() {
			this.dialogOpen = false;
			// important: put focus back on element that triggered the dialog
			if (this.dialogOpener) {
				this.dialogOpener.focus();
			}
		},
	},
};
</script>

<style lang="scss">
.ReportHelp {
	line-height: 1;
	.Button.Button--link {
		line-height: inherit;
		.Icon {
			width: 1.5rem;
			height: 1.5rem;
		}
	}
}
</style>
